// src/store/index.js
import { configureStore, combineReducers } from "@reduxjs/toolkit";
import authReducer from "./authReducers";
import propertyReducer from "./propertyReducers";
import { setupInterceptors } from "../utils/api";
const rootReducer = combineReducers({
  auth: authReducer,
  property: propertyReducer,
});

const store = configureStore({
  reducer: rootReducer,
});

setupInterceptors(store);

export default store;
